import { Button, Chip, styled } from "@mui/material";

export const Label = styled("span")`
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.neutral.medium[800]};
`;

interface ButtonStyledProps {
  selected?: boolean;
}

export const FilterButton = styled(Button, {
  shouldForwardProp: prop => prop !== "selected",
})<ButtonStyledProps>`
  &.MuiButton-outlined {
    border-radius: 14px;
    background: ${({ theme, selected }) =>
      selected
        ? theme.palette.primary.medium
        : theme.colors.neutral.light[100]};
    color: ${({ theme, selected }) =>
      selected ? theme.palette.primary.main : theme.colors.neutral.dark[700]};
    border-color: ${({ theme, selected }) =>
      selected ? theme.palette.primary.main : theme.colors.neutral.light[200]};
    white-space: nowrap;
    min-width: unset;
  }
`;

interface FilterChipProps {
  selected?: boolean;
}

export const FilterChip = styled(Chip, {
  shouldForwardProp: prop => prop !== "selected",
})<FilterChipProps>`
  &.MuiChip-outlined {
    border: 1px solid ${({ theme }) => theme.palette.primary.main};
    background: ${({ selected, theme }) =>
      selected
        ? theme.palette.primary.medium
        : theme.colors.neutral.light[100]};
  }
`;

export const OptionsWrapper = styled("div")`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;
